function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable prefer-spread */
import * as React from 'react';
import { BodyCell, BodyRow, LoadingCellContent } from './styles'; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

var SkeletonLoader = function SkeletonLoader(_ref) {
  var cellStyles = _ref.cellStyles,
      numColumns = _ref.numColumns,
      numRows = _ref.numRows,
      rowStyles = _ref.rowStyles;
  return /*#__PURE__*/React.createElement(React.Fragment, null, Array.apply(null, {
    length: numRows
  }).map(function (el, rowIndex) {
    return /*#__PURE__*/React.createElement(BodyRow, {
      key: "table-loading-row-".concat(rowIndex),
      customStyles: _objectSpread({}, rowStyles)
    }, Array.apply(null, {
      length: numColumns
    }).map(function (el, cellIndex) {
      return /*#__PURE__*/React.createElement(BodyCell, {
        key: "table-loading-cell-".concat(rowIndex, "-").concat(cellIndex),
        customStyles: _objectSpread({}, cellStyles)
      }, /*#__PURE__*/React.createElement(LoadingCellContent, {
        "aria-label": "Loading table cell content"
      }));
    }));
  }));
};

export default SkeletonLoader;